import FormattedMessage from 'I18n/components/FormattedMessage';
import { RouterLink } from '../../../components/AcademyLinks';
import HomePageSection from '../../../components/Layouts/HomePageSection';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import { getSearchUrl } from '../../search/searchRouting';
import UsageTracker from '../../../utils/UsageTracker';
import { useInternalContentItems } from '../internalContentQueries';
import { CardsSection } from 'academy-common-lib/features/cardsSection/components/CardsSection';
import { useState } from 'react';
import { HasGate } from '../../accounts/components/HasGate';
import { NavMarker } from 'react-rhumb';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PAGE_SIZE = 4;
const ViewAllLink = () => {
  const {
    isMobile
  } = useMediaQuery();
  const trackViewAllClick = () => UsageTracker.track('interaction', {
    action: 'internal-content-view-all-clicked'
  });
  return /*#__PURE__*/_jsx(RouterLink, {
    marginInlineStart: "200",
    onClick: trackViewAllClick,
    to: getSearchUrl({
      contentSource: 'CUSTOM_CONTENT'
    }),
    underline: true,
    children: isMobile ? /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.internalContentSection.seeAll"
    }) : /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.internalContentSection.viewAll"
    })
  });
};
const InternalContentSection = ({
  renderCompact,
  onRenderEmpty
}) => {
  const [maxCards, setMaxCards] = useState();
  const pageLength = renderCompact ? 3 : maxCards;
  const {
    internalContentItems,
    internalContentItemsLoading,
    internalContentItemsError,
    totalCount
  } = useInternalContentItems({
    pageLength,
    skip: !maxCards
  });
  const showViewMoreLink = totalCount > PAGE_SIZE;
  if (maxCards && !internalContentItemsLoading && !internalContentItemsError && !(internalContentItems !== null && internalContentItems !== void 0 && internalContentItems.length)) return /*#__PURE__*/_jsx(NavMarker, {
    name: "HOMEPAGE_FEATURED_SECTION_LOADED"
  });
  return /*#__PURE__*/_jsx(HomePageSection, {
    paddingBlock: "0",
    children: /*#__PURE__*/_jsx(CardsSection, {
      appearsIn: "internal-content-homepage",
      cardsContainerProps: {
        paddingBlockEnd: '0'
      },
      content: internalContentItems,
      description: /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.internalContentSection.description"
        }), renderCompact && showViewMoreLink && /*#__PURE__*/_jsx(ViewAllLink, {})]
      }),
      direction: renderCompact ? 'column' : 'row',
      error: internalContentItemsError,
      errorMarker: "HOMEPAGE_FEATURED_SECTION_ERROR",
      flush: true,
      header: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.internalContentSection.title"
      }),
      headerActions: !renderCompact && showViewMoreLink && /*#__PURE__*/_jsx(ViewAllLink, {}),
      isLoading: !maxCards || internalContentItemsLoading,
      maxSkeletonListLength: pageLength,
      navMarker: "HOMEPAGE_FEATURED_SECTION_LOADED",
      onRenderEmpty: onRenderEmpty,
      setMaxCards: setMaxCards,
      size: renderCompact ? 'small' : 'large'
    })
  });
};
export const FeaturedSection = ({
  renderCompact,
  onRenderEmpty
}) => {
  // TODO: When this gate is fully ungated, uncomment HOMEPAGE_FEATURED_SECTION markers in rhumb-config.yaml
  return /*#__PURE__*/_jsx(HasGate, {
    gate: "Academy:TrainerContent",
    children: /*#__PURE__*/_jsx(InternalContentSection, {
      onRenderEmpty: onRenderEmpty,
      renderCompact: renderCompact
    })
  });
};
export default FeaturedSection;